module.exports = __webpack_public_path__ + "img/_cross-resonance-dagger_.a903a12b.svg";